import { useState, useEffect } from "react";
import moment from "moment";
import InputNumber from "../../../../shared/components/inputs/InputNumber/InputNumber";
import InputText from "../../../../shared/components/inputs/InputText/InputText";
import InputSelect from "../../../../shared/components/inputs/InputSelect/InputSelect";
//MUI
import Box from "@mui/material/Box";
import Modal from "@mui/material/Modal";
import TextField from "@mui/material/TextField";
import { LocalizationProvider } from "@mui/x-date-pickers/LocalizationProvider";
import { AdapterMoment } from "@mui/x-date-pickers/AdapterMoment";
import { DesktopDatePicker } from "@mui/x-date-pickers/DesktopDatePicker";
import { useLoading } from "../../../../shared/context/LoadingContext";
import Autocomplete from "@mui/material/Autocomplete";

import toast from "react-hot-toast";
import "./ModalDespesaRecorrente.scss";
import {
  opcoesDeCaixa,
  caixaParaMetodo,
  metodoParaCaixa,
} from "../../../../shared/util/caixaEMetodo";

const formasPagamento = [
  "Dinheiro",
  "Cheque",
  "Cheque Visado",
  "Transferência de crédito",
  "Internet banking",
  "Cartão do banco",
  "Débito direto da conta bancária",
  "Cartão de crédito",
  "Cartão de débito",
];

const tiposRepeticao = [
  { value: "semanal", label: "Semanal" },
  { value: "quinzenal", label: "Quinzenal" },
  { value: "mensal", label: "Mensal" },
  { value: "bimestral", label: "Bimestral" },
  { value: "trimestral", label: "Trimestral" },
  { value: "semestral", label: "Semestral" },
  { value: "anual", label: "Anual" },
];

function ModalDespesaRecorrente({
  openModalDespesaRecorrente,
  handleCloseModalDespesaRecorrente,
  sendRequest,
  clinicaId,
  updateDespesasRecorrentes,
  auth,
}) {
  const { startLoading, stopLoading } = useLoading();

  const [isSubmitting, setIsSubmitting] = useState(false);
  const [openModal, setOpenModal] = useState(openModalDespesaRecorrente);
  const [descricao, setDescricao] = useState("");
  const [valor, setValor] = useState(0);
  const [observacao, setObservacao] = useState("");
  const [categoria, setCategoria] = useState();
  const [categorias, setCategorias] = useState([]);
  const [caixa, setCaixa] = useState();
  const [caixas, setCaixas] = useState([]);
  const [dataTermino, setDataTermino] = useState(moment().add(1, "year"));
  const [dataInicio, setDataInicio] = useState(moment());
  const [despesaPaga, setDespesaPaga] = useState(false);
  const [tipoRepeticao, setTipoRepeticao] = useState("mensal");

  const [metodoPagamento, setMetodoPagamento] = useState(formasPagamento[0]);
  const [listaFornecedores, setListaFornecedores] = useState([]);
  const [fornecedor, setFornecedor] = useState("");
  const [listaClientes, setListaClientes] = useState([]);
  const [cliente, setCliente] = useState("");
  const [listaFuncionariosEUtilizadores, setListaFuncionariosEUtilizadores] =
    useState([]);
  const [funcionarioSelecionado, setFuncionarioSelecionado] = useState(null);
  const [tipoBeneficiario, setTipoBeneficiario] = useState("fornecedor");
  const [fornecedorTexto, setFornecedorTexto] = useState("");

  useEffect(() => {
    const fetchData = async () => {
      startLoading();
      try {
        const [
          categoriasResponse,
          caixasResponse,
          fornecedoresResponse,
          clientesResponse,
          funcionariosResponse,
          utilizadoresResponse,
        ] = await Promise.all([
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/categoriasfinanceiro/clinica/despesa/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/caixas/clinica/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/fornecedores/clinica/despesa/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/clientes/nomeid/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/funcionarios/clinica/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
          sendRequest(
            `${process.env.REACT_APP_BACKEND_LINK}/api/users/ativos/${clinicaId}`,
            "GET",
            null,
            { Authorization: "Bearer " + auth.token },
          ),
        ]);

        // Process categorias
        const categoriasFormatted = categoriasResponse.categoriasFinanceiro.map(
          (cat) => ({
            id: cat.id,
            value: cat.categoria,
          }),
        );
        setCategorias(categoriasFormatted);
        setCategoria(categoriasFormatted[0]?.id);

        // Process caixas
        const caixasFormatted = caixasResponse.caixas.map((cai) => ({
          id: cai.id,
          value: cai.caixa,
        }));
        setCaixas(caixasFormatted);
        setCaixa(caixasFormatted[0]?.id);

        // Process fornecedores
        const fornecedoresFormatted = fornecedoresResponse.fornecedores.map(
          (forn) => ({
            id: forn.id,
            value: forn.nome,
          }),
        );

        setListaFornecedores(fornecedoresFormatted);
        setListaClientes(clientesResponse.clientes);

        setListaFuncionariosEUtilizadores([
          ...funcionariosResponse.funcionarios.map((f) => ({
            id: f.id,
            value: f.nome,
            tipo: "Funcionario",
          })),
          ...utilizadoresResponse.users.map((u) => ({
            id: u.id,
            value: u.name,
            tipo: "User",
          })),
        ]);
      } catch (err) {
        console.error("err", err);
      } finally {
        stopLoading();
      }
    };

    fetchData();
  }, [auth.token, clinicaId, sendRequest]);

  useEffect(() => {
    setOpenModal(openModalDespesaRecorrente);
  }, [openModalDespesaRecorrente]);

  const descricaoChangeHandler = (value) => {
    setDescricao(value);
  };

  const valorChangeHandler = (value) => {
    setValor(value);
  };

  /* Método e caixa andam juntos: dinheiro é da caixa "Clínica", tudo o resto
     sai de um banco. Cada despesa gerada por esta recorrência herda os dois,
     por isso o erro aqui repetir-se-ia todos os meses.
     Ver `shared/util/caixaEMetodo`. */
  const metodoPagamentoChangeHandler = (valor) => {
    setMetodoPagamento(valor);
    setCaixa((atual) => caixaParaMetodo(caixas, valor, atual));
  };

  const caixaChangeHandler = (novaCaixa) => {
    setCaixa(novaCaixa);
    setMetodoPagamento((atual) =>
      metodoParaCaixa(caixas, novaCaixa, atual, formasPagamento),
    );
  };

  const guardarDespesaHandler = async () => {
    startLoading();
    try {
      const formData = new FormData();
      formData.append("clinica", clinicaId);
      formData.append("observacoes", observacao ? observacao : "");
      formData.append("descricao", descricao);
      formData.append("valor", valor);
      formData.append("tipoRepeticao", tipoRepeticao);
      formData.append("categoria", categoria);
      formData.append("caixa", caixa);
      formData.append("criadoPor", auth.userId);
      formData.append("dataTermino", moment(dataTermino).format("MM-DD-YYYY"));
      formData.append("dataInicio", moment(dataInicio).format("MM-DD-YYYY"));

      if (fornecedor) formData.append("fornecedor", fornecedor);
      if (cliente) formData.append("cliente", cliente);

      if (despesaPaga) {
        formData.append("metodoPagamento", metodoPagamento);
        formData.append("despesaPaga", true);
      } else {
        formData.append("despesaPaga", false);
      }

      if (funcionarioSelecionado) {
        if (funcionarioSelecionado.tipo === "Funcionario") {
          formData.append("funcionario", funcionarioSelecionado.id);
        } else {
          formData.append("funcionarioUser", funcionarioSelecionado.id);
        }
      }

      const despesaAdicionada = await sendRequest(
        `${process.env.REACT_APP_BACKEND_LINK}/api/despesasrecorrentes`,
        "POST",
        formData,
        {
          Authorization: "Bearer " + auth.token,
        },
      );

      updateDespesasRecorrentes(despesaAdicionada.despesaRecorrente, "novo");

      if (dataInicio.isSame(moment(), "day")) {
        toast.success(
          "Saída recorrente adicionada com sucesso! Primeria saída automaticamente lançada em financeiro.",
        );
      } else {
        toast.success("Saída recorrente adicionada com sucesso!");
      }

      handleCloseModalDespesaRecorrente();
    } catch (err) {
      console.error("err", err);
    } finally {
      stopLoading();
      setIsSubmitting(false);
    }
  };

  const preGuardarDespesaHandler = () => {
    if (valor === 0 || valor < 0) {
      toast.error("O valor da saída deve ser > 0");
    } else if (!descricao || descricao.trim().length === 0) {
      toast.error("Introduza uma descrição");
    } else if (!dataTermino) {
      toast.error("Introduza a data de término");
    } else if (!moment.isMoment(dataTermino) || !dataTermino.isValid()) {
      toast.error("Introduza a data de término corretamente");
    } else if (!dataInicio) {
      toast.error("Introduza a data de inicio");
    } else if (!moment.isMoment(dataInicio) || !dataInicio.isValid()) {
      toast.error("Introduza a data de inicio corretamente");
    } else if (!isSubmitting) {
      setIsSubmitting(true);
      guardarDespesaHandler();
    }
  };

  const handleClienteChange = (value) => {
    setCliente(value);
  };

  const handleFornecedorChange = (value, isTexto = false) => {
    if (isTexto) {
      setFornecedorTexto(value);
      setFornecedor("");
    } else {
      setFornecedor(value);
      setFornecedorTexto("");
    }
  };
  return (
    <>
      <Modal
        open={openModal}
        onClose={handleCloseModalDespesaRecorrente}
        aria-labelledby="modal-modal-title"
        aria-describedby="modal-modal-description"
      >
        <Box
          className="fluxo-atendimento__modal__box adicionar-despesa__modal"
          id="modal__adicionar-despesa"
        >
          <h1 className="fluxo-atendimento__modal__titulo">
            Nova saída recorrente
          </h1>
          <div className="adicionar-despesa__modal__container">
            <InputText
              className="adicionar-despesa__modal__container--span2"
              label="Descrição *"
              initialValue={descricao}
              handleChange={descricaoChangeHandler}
            />
            <InputNumber
              className="adicionar-despesa__modal__container--span1"
              label="Valor *"
              initialValue={valor}
              handleChange={valorChangeHandler}
            />
            <div className="customInputContainer adicionar-despesa__modal__container--span1">
              <select
                onChange={(e) => setTipoRepeticao(e.target.value)}
                className="customInputSelect"
                value={tipoRepeticao}
              >
                {tiposRepeticao.map((tipo) => (
                  <option key={tipo.value} value={tipo.value}>
                    {tipo.label}
                  </option>
                ))}
              </select>
              <label className="customInputLabelSelect">
                Tipo de repetição
              </label>
            </div>

            <div className="adicionar-despesa__modal__container--span2">
              <div className="customInputContainer">
                <select
                  onChange={(e) => {
                    setTipoBeneficiario(e.target.value);
                    setCliente("");
                    setFornecedor("");
                    setFornecedorTexto("");
                    setFuncionarioSelecionado(null);
                  }}
                  className="customInputSelect"
                  value={tipoBeneficiario}
                >
                  <option value="fornecedor">Fornecedor</option>
                  <option value="cliente">Cliente</option>
                  <option value="funcionario">Funcionário</option>
                </select>
                <label className="customInputLabelSelect">
                  Tipo de Beneficiário
                </label>
              </div>
            </div>

            {tipoBeneficiario === "fornecedor" && listaFornecedores && (
              <div
                className="adicionar-despesa__modal__container--span2"
                style={{ position: "relative" }}
              >
                <Autocomplete
                  className="saida__autocomplete"
                  freeSolo
                  options={listaFornecedores}
                  getOptionLabel={(option) =>
                    typeof option === "string" ? option : option.value
                  }
                  value={
                    fornecedor
                      ? listaFornecedores.find((f) => f.id === fornecedor) ||
                        null
                      : fornecedorTexto || null
                  }
                  onChange={(event, newValue) => {
                    if (typeof newValue === "string")
                      handleFornecedorChange(newValue, true);
                    else if (newValue && newValue.id)
                      handleFornecedorChange(newValue.id, false);
                    else handleFornecedorChange("", false);
                  }}
                  onInputChange={(event, newInputValue) => {
                    if (event?.type === "change") {
                      const opcaoExistente = listaFornecedores.find(
                        (f) => f.value === newInputValue,
                      );
                      if (opcaoExistente)
                        handleFornecedorChange(opcaoExistente.id, false);
                      else handleFornecedorChange(newInputValue, true);
                    }
                  }}
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Fornecedor"
                      variant="outlined"
                    />
                  )}
                />
              </div>
            )}

            {tipoBeneficiario === "cliente" && listaClientes && (
              <div className="adicionar-despesa__modal__container--span2">
                <Autocomplete
                  className="saida__autocomplete"
                  freeSolo
                  options={listaClientes}
                  getOptionLabel={(option) =>
                    typeof option === "string" ? option : option.nome
                  }
                  value={listaClientes.find((c) => c.id === cliente) || null}
                  onChange={(event, newValue) => {
                    if (typeof newValue === "string")
                      handleClienteChange(newValue);
                    else if (newValue && newValue.id)
                      handleClienteChange(newValue.id);
                    else handleClienteChange("");
                  }}
                  onInputChange={(event, newInputValue) => {
                    if (event?.type === "change")
                      handleClienteChange(newInputValue);
                  }}
                  renderInput={(params) => (
                    <TextField {...params} label="Cliente" variant="outlined" />
                  )}
                />
              </div>
            )}

            {tipoBeneficiario === "funcionario" && (
              <div className="adicionar-despesa__modal__container--span2">
                <Autocomplete
                  className="saida__autocomplete"
                  options={listaFuncionariosEUtilizadores}
                  getOptionLabel={(option) => option.value || ""}
                  groupBy={(option) =>
                    option.tipo === "Funcionario"
                      ? "Funcionários"
                      : "Utilizadores do Sistema"
                  }
                  value={funcionarioSelecionado}
                  onChange={(event, newValue) =>
                    setFuncionarioSelecionado(newValue)
                  }
                  renderInput={(params) => (
                    <TextField
                      {...params}
                      label="Funcionário"
                      variant="outlined"
                    />
                  )}
                />
              </div>
            )}

            {categorias && categoria && (
              <div className="customInputContainer adicionar-despesa__modal__container--span2">
                <select
                  onChange={(e) => setCategoria(e.target.value)}
                  className="customInputSelect"
                  value={categoria}
                >
                  {categorias &&
                    categoria &&
                    categorias.map((item, index) => (
                      <option key={index} value={item.id}>
                        {item.value}
                      </option>
                    ))}
                </select>
                <label className="customInputLabelSelect">Categoria</label>
              </div>
            )}
            {caixas && caixa && (
              <div className="customInputContainer adicionar-despesa__modal__container--span2">
                <select
                  onChange={(e) => caixaChangeHandler(e.target.value)}
                  className="customInputSelect"
                  value={caixa}
                >
                  {/* Enquanto não é dada como paga não há método, e todas as
                      caixas servem. A partir daí manda a regra. */}
                  {(despesaPaga
                    ? opcoesDeCaixa(caixas, metodoPagamento, caixa)
                    : caixas
                  ).map((item) => (
                    <option key={item.id} value={item.id}>
                      {item.value}
                    </option>
                  ))}
                </select>
                <label className="customInputLabelSelect">Caixa</label>
              </div>
            )}

            <LocalizationProvider
              dateAdapter={AdapterMoment}
              className="adicionar-despesa__modal__container--span1"
            >
              <DesktopDatePicker
                className="valorDataCaixa__fields--field muiDatePicker"
                label="Data de inicio*"
                inputFormat="DD-MM-YYYY"
                value={dataInicio}
                onChange={(value) => setDataInicio(value)}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>
            <LocalizationProvider
              dateAdapter={AdapterMoment}
              className="adicionar-despesa__modal__container--span1"
            >
              <DesktopDatePicker
                className="valorDataCaixa__fields--field muiDatePicker"
                label="Data de término*"
                inputFormat="DD-MM-YYYY"
                value={dataTermino}
                onChange={(value) => setDataTermino(value)}
                renderInput={(params) => <TextField {...params} />}
              />
            </LocalizationProvider>

            <textarea
              cols="30"
              rows="7"
              placeholder="observacao"
              value={observacao}
              onChange={(e) => setObservacao(e.target.value)}
              className="adicionar-despesa__modal__container__textarea"
            ></textarea>
          </div>

          <div className="adicionar-despesa__modal__container__checkbox-pago__container">
            <input
              type="checkbox"
              name=""
              id="ja-foi-pago-checkbox"
              onChange={(e) => setDespesaPaga(e.target.checked)}
              checked={despesaPaga}
            />
            <label htmlFor="ja-foi-pago-checkbox">
              Essa saída fica como paga
            </label>
          </div>

          {despesaPaga && (
            <div className="adicionar-despesa__modal__pagamento">
              <InputSelect
                label="Forma de pagamento"
                initialValue={metodoPagamento}
                handleChange={metodoPagamentoChangeHandler}
                items={formasPagamento}
              />
            </div>
          )}
          <div className="fluxo-atendimento__modal__bottom_btns">
            <span
              className="cancel-btn"
              onClick={handleCloseModalDespesaRecorrente}
              style={{ display: "block" }}
            >
              Fechar
            </span>

            <span
              disabled={isSubmitting}
              className="blue-button"
              onClick={preGuardarDespesaHandler}
            >
              {isSubmitting ? "Guardando..." : "Guardar"}
            </span>
          </div>
        </Box>
      </Modal>
    </>
  );
}

export default ModalDespesaRecorrente;
